//**************************************************************************************************
//  ログインガード
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';

import { SessionService } from '../service/session.service';
//==================================================================================================
//
//==================================================================================================
export const loginGuard: CanActivateFn = (route, state) => {

  const sessionService: SessionService = inject(SessionService);
  const router: Router = inject(Router);

  return sessionService.checkLoginState().pipe(map(session => {
    if (!session.isLogin) {
      return true;
    } else {
      if (!!session.sysAdmin || !!session.opAdmin || !!session.opUser) {
        sessionService.logout();
      }
      return false;
    }
  }));

};
